import privacyPolicyCopyLaos from "../../../../src/content/laos-landing-page/privacyPolicy";
import customConfirmationLaos from "../../../../src/content/laos-landing-page/customConfirmation.js";
import { GetInvolved } from '@bgea-js/form-templates';
import * as React from 'react';
export default {
  privacyPolicyCopyLaos,
  customConfirmationLaos,
  GetInvolved,
  React
};